import React from 'react';
import type { UseSortByColumnProps } from 'react-table';
import { MaterialIcon } from '../../../components';
import { GLOBAL_ICONS } from '../../../util/vars';
import { TABLE_SORT } from '../../../util/data-id';

interface Props {
  column: UseSortByColumnProps<Record<string, unknown>>;
}

const Sort = ({ column }: Props): JSX.Element | null => {
  if (!column.isSorted) {
    return null;
  }
  return (
    <button data-id={TABLE_SORT} type={'button'}>
      <MaterialIcon
        color={'dark'}
        size={'sm'}
        icon={GLOBAL_ICONS[column.isSortedDesc ? 'sort_down' : 'sort_up']}
      />
    </button>
  );
};

Sort.displayName = 'Sort';

export default Sort;
